import React, {useState, useEffect} from "react"
import PartOne from "./partOne/PartOne"
import PartTwo from "./partTwo/PartTwo"
import PartThree from "./partThree/PartThree"
import PartFour from "./partFour/PartFour"
import PartFive from "./partFive/PartFive"
import Overlay from "./Overlay"

function PuzzleContent(props) {
    const [overlayText, setOverlayText] = useState("")
    const [pageId, setPageId] = useState(0)
    const [gameComplete, setGameComplete] = useState(false)
    const [code, setCode] = useState("")
    
    useEffect(() => {
        setPageId(props.currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentPage])
    
    useEffect(() => {
        setCode([
            0, 
            <PartOne callBackKeypad={props.callBackKeypad} callBackRevealClues={props.callBackRevealClues} callBackOverlay={handleOverlay} partStatus={props.partStatus[1].status} />, 
            
            <PartTwo partStatus={props.partStatus[2].status} />, 
            
            <PartThree callBack={handleOverlay} callBackRevealClues={props.callBackRevealClues} partStatus={props.partStatus[3].status} />, 
            
            <PartFour barClicked={props.barClicked} callBackKeypad={props.callBackKeypad} callBackGameUpdate={props.callBackGameUpdate} timeLimit={props.timeLimit} callBackRevealClues={props.callBackRevealClues} partStatus={props.partStatus[4].status} />, 
            
            <PartFive callBackOverlay={handleOverlay} callBackRevealClues={props.callBackRevealClues} partStatus={props.partStatus[5].status} />, 
        ])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageId, props.barClicked, props.timeLimit])

    function handleOverlay(power, text, trigger) {
        if (power === 'on') {
            setOverlayText(text)
            document.getElementById("overlay").style.display = "block"
            if (trigger === "briefcase") {
                setGameComplete(true)
            }
        } else {
            document.getElementById("overlay").style.display = "none"
            if (gameComplete) { 
                const pageTarget = 6
                props.callBackPage(pageTarget)
            }
        }
    }

    return (
        <div>
            {code[pageId]}
            <Overlay overlayText={overlayText} callBack={handleOverlay}/>
        </div>
    )
}
        
export default PuzzleContent